import { render, staticRenderFns } from "./Company-info.vue?vue&type=template&id=73b7f89c&scoped=true&"
import script from "./Company-info.vue?vue&type=script&lang=js&"
export * from "./Company-info.vue?vue&type=script&lang=js&"
import style0 from "./Company-info.vue?vue&type=style&index=0&id=73b7f89c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b7f89c",
  null
  
)

export default component.exports